import { render, staticRenderFns } from "./CustomerNotes.template.vue?vue&type=template&id=6a06426c&scoped=true&"
var script = {}
import style0 from "./CustomerNotes.template.vue?vue&type=style&index=0&id=6a06426c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a06426c",
  null
  
)

export default component.exports